/* Generated by restful-react */

import React from 'react'
import {
  Get,
  GetProps,
  useGet,
  UseGetProps,
  Mutate,
  MutateProps,
  useMutate,
  UseMutateProps,
} from 'restful-react'

export const SPEC_VERSION = 'v9'
export interface StaplesHeadhaulLanesFilters {
  carrierApplicationId?: number
  pickupCity?: string
  deliveryCity?: string
}

export interface StaplesHeadhaulLanesResponse {
  staplesHeadhaulLanes?: StaplesHeadhaulLane[]
  totalCount?: number
}

export interface StaplesHeadhaulLane {
  id: number
  createdAt?: string
  updatedAt?: string
  carrierApplication?: CarrierApplication
  pickupPostalCode?: string | null
  pickupCity?: string
  pickupStateCode?: string
  deliveryPostalCode?: string | null
  deliveryCity?: string
  deliveryStateCode?: string
  pickupLatitude?: string | null
  pickupLongitude?: string | null
  deliveryLatitude?: string | null
  deliveryLongitude?: string | null
  mapboxMiles?: string | null
  dailyTrucks?: number | null
  weeklyTrucks?: number | null
  pickupWindow?: string | null
  deliveryWindow?: string | null
  notes?: string | null
}

export interface CarrierApplication {
  id: number
  name?: string
}

export interface StaplesHeadhaulLaneRequest {
  carrierApplicationId?: number
  pickupPostalCode?: string | null
  pickupCity: string
  pickupStateCode: string
  deliveryPostalCode?: string | null
  deliveryCity: string
  deliveryStateCode: string
  pickupLatitude?: string | null
  pickupLongitude?: string | null
  deliveryLatitude?: string | null
  deliveryLongitude?: string | null
  mapboxMiles?: string | null
  dailyTrucks?: number | null
  weeklyTrucks?: number | null
  pickupWindow?: string | null
  deliveryWindow?: string | null
  notes?: string | null
}

export interface GetStaplesHeadhaulLanesQueryParams {
  /**
   * Filters
   */
  filters?: StaplesHeadhaulLanesFilters
  /**
   * Page number of request
   */
  pageCount?: number
}

export type GetStaplesHeadhaulLanesProps = Omit<
  GetProps<StaplesHeadhaulLanesResponse, unknown, GetStaplesHeadhaulLanesQueryParams, void>,
  'path'
>

/**
 * Get all staples headhaul lanes
 */
export const GetStaplesHeadhaulLanes = (props: GetStaplesHeadhaulLanesProps) => (
  <Get<StaplesHeadhaulLanesResponse, unknown, GetStaplesHeadhaulLanesQueryParams, void>
    path='/v9/staples_headhaul_lanes'
    {...props}
  />
)

export type UseGetStaplesHeadhaulLanesProps = Omit<
  UseGetProps<StaplesHeadhaulLanesResponse, unknown, GetStaplesHeadhaulLanesQueryParams, void>,
  'path'
>

/**
 * Get all staples headhaul lanes
 */
export const useGetStaplesHeadhaulLanes = (props: UseGetStaplesHeadhaulLanesProps) =>
  useGet<StaplesHeadhaulLanesResponse, unknown, GetStaplesHeadhaulLanesQueryParams, void>(
    `/v9/staples_headhaul_lanes`,
    props
  )

export type CreateStaplesHeadhaulLaneProps = Omit<
  MutateProps<void, unknown, void, StaplesHeadhaulLaneRequest, void>,
  'path' | 'verb'
>

/**
 * Create a new staples headhaul lane
 */
export const CreateStaplesHeadhaulLane = (props: CreateStaplesHeadhaulLaneProps) => (
  <Mutate<void, unknown, void, StaplesHeadhaulLaneRequest, void>
    verb='POST'
    path='/v9/staples_headhaul_lanes'
    {...props}
  />
)

export type UseCreateStaplesHeadhaulLaneProps = Omit<
  UseMutateProps<void, unknown, void, StaplesHeadhaulLaneRequest, void>,
  'path' | 'verb'
>

/**
 * Create a new staples headhaul lane
 */
export const useCreateStaplesHeadhaulLane = (props: UseCreateStaplesHeadhaulLaneProps) =>
  useMutate<void, unknown, void, StaplesHeadhaulLaneRequest, void>(
    'POST',
    `/v9/staples_headhaul_lanes`,
    props
  )

export interface UpdateStaplesHeadhaulLanePathParams {
  /**
   * Id of lane to update
   */
  staplesHeadhaulLaneId: number
}

export type UpdateStaplesHeadhaulLaneProps = Omit<
  MutateProps<void, unknown, void, StaplesHeadhaulLaneRequest, UpdateStaplesHeadhaulLanePathParams>,
  'path' | 'verb'
> &
  UpdateStaplesHeadhaulLanePathParams

/**
 * Update an existing staples headhaul lane
 */
export const UpdateStaplesHeadhaulLane = ({
  staplesHeadhaulLaneId,
  ...props
}: UpdateStaplesHeadhaulLaneProps) => (
  <Mutate<void, unknown, void, StaplesHeadhaulLaneRequest, UpdateStaplesHeadhaulLanePathParams>
    verb='PUT'
    path={`/v9/staples_headhaul_lanes/${staplesHeadhaulLaneId}`}
    {...props}
  />
)

export type UseUpdateStaplesHeadhaulLaneProps = Omit<
  UseMutateProps<
    void,
    unknown,
    void,
    StaplesHeadhaulLaneRequest,
    UpdateStaplesHeadhaulLanePathParams
  >,
  'path' | 'verb'
> &
  UpdateStaplesHeadhaulLanePathParams

/**
 * Update an existing staples headhaul lane
 */
export const useUpdateStaplesHeadhaulLane = ({
  staplesHeadhaulLaneId,
  ...props
}: UseUpdateStaplesHeadhaulLaneProps) =>
  useMutate<void, unknown, void, StaplesHeadhaulLaneRequest, UpdateStaplesHeadhaulLanePathParams>(
    'PUT',
    (paramsInPath: UpdateStaplesHeadhaulLanePathParams) =>
      `/v9/staples_headhaul_lanes/${paramsInPath.staplesHeadhaulLaneId}`,
    { pathParams: { staplesHeadhaulLaneId }, ...props }
  )

export type DeleteStaplesHeadhaulLaneProps = Omit<
  MutateProps<void, unknown, void, number, void>,
  'path' | 'verb'
>

/**
 * Delete an existing staples headhaul lane
 */
export const DeleteStaplesHeadhaulLane = (props: DeleteStaplesHeadhaulLaneProps) => (
  <Mutate<void, unknown, void, number, void>
    verb='DELETE'
    path='/v9/staples_headhaul_lanes'
    {...props}
  />
)

export type UseDeleteStaplesHeadhaulLaneProps = Omit<
  UseMutateProps<void, unknown, void, number, void>,
  'path' | 'verb'
>

/**
 * Delete an existing staples headhaul lane
 */
export const useDeleteStaplesHeadhaulLane = (props: UseDeleteStaplesHeadhaulLaneProps) =>
  useMutate<void, unknown, void, number, void>('DELETE', `/v9/staples_headhaul_lanes`, { ...props })
